// extracted by mini-css-extract-plugin
export var noSpinners = "_sa-6";
export var percentageInput = "_sa-7";
export var variantColor1 = "_sa-0";
export var variantColor2 = "_sa-1";
export var variantColor3 = "_sa-2";
export var variantColor4 = "_sa-3";
export var variantColor5 = "_sa-4";
export var variantColor6 = "_sa-5";